import { Card, Divider, Flex, Form } from 'antd'
import { FormInstance } from 'antd/lib'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useTreatmentServiceGetTreatmentPlanAdverseEffectEntryListEndpoint } from 'src/api/queries'
import { GetTreatmentPlanResponse } from 'src/api/requests'
import { Text } from 'src/components'
import {
  Recipes,
  Treatment
} from 'src/features/persons/components/PersonConsultations/Treatments'
import { usePersonBreadcrumb } from 'src/features/persons/hooks'
import { useLocales } from 'src/locales'

import { PersonReactionsList } from './PersonReactionsList'
import { useStyles } from './styles'

type Props = {
  data?: GetTreatmentPlanResponse
  form: FormInstance
}

export const TreatmentBody = ({ data, form }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()
  const { personId } = useParams()

  const { person } = usePersonBreadcrumb(personId)

  const { data: adverseReactions } =
    useTreatmentServiceGetTreatmentPlanAdverseEffectEntryListEndpoint(
      {
        id: String(data?.id)
      },
      [String(data?.id)],
      {
        enabled: !!data?.id
      }
    )

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        isUrgent: data?.isUrgent,
        treatment_start_date: data?.created ? dayjs(data?.created) : undefined,
        treatment_end_date: data?.endDate ? dayjs(data?.endDate) : undefined,
        treatment_type: data?.treatmentType?.id,
        status: data?.status,
        treatmentTypeRegimenId: data?.treatmentTypeRegimen?.id,
        treatmentPlanId: data?.id,
        medicine: data?.prescribedTreatments?.map((item) => ({
          id: item?.id,
          name: item?.internationalName?.name,
          internationalNameId: item?.internationalName?.id,
          productFormId: {
            name: item?.productForm?.name,
            id: item?.productForm?.id
          },
          amount: item?.amount,
          cron: item?.scheduleExpression,
          startDate: item?.startDate ? dayjs(item?.startDate) : undefined,
          endDate: item?.endDate ? dayjs(item?.endDate) : undefined,
          durationInDays: item?.durationInDays,
          amountToAdminister: item?.amountToAdminister,
          totalAdministered: item?.totalAdministered
        }))
      })
    }
  }, [data, form])

  return (
    <Flex gap={16} vertical>
      <Card bordered className={styles.treatmentCard}>
        <Divider />

        <Flex key={1} vertical gap={24} className={styles.treatmentContent}>
          <Text size="xl">{t('persons.treatment.treatment_prescribed')}</Text>
          <Treatment form={form} person={person} />
        </Flex>

        <Divider />

        <Form.Item shouldUpdate>
          {() => {
            return <Recipes form={form} hideCreateButton />
          }}
        </Form.Item>

        <Divider />
        <PersonReactionsList
          data={adverseReactions?.data}
          treatmentPlanId={data?.id}
        />
      </Card>
    </Flex>
  )
}
